import { IFile, IImage, ISEO, ISocial } from '@/interfaces/common'
import { getFileExtension } from '@/shared/utils'
import { getFileUrl } from '@/shared/utils/directus'
import { defaultLocaleFull } from '@/shared/utils/directus'
export function mapFileFields(file?: Directus.File | null): IFile | null {
  if (!file) return null
  return {
    ...file,
    url: getFileUrl(file.id),
    type: getFileExtension(file.filename_disk) || getFileExtension(file.filename_download) || '',
  }
}

export function mapImageFields(image?: Directus.Image | null): IImage | null {
  if (!image) return null
  return {
    ...image,
    url: getFileUrl(image.id),
  }
}

export function mapSEOFields(item?: Directus.SEO | null): ISEO | null {
  if (!item?.translations?.[0]) return null
  return {
    ...item.translations[0],
    image_ru: mapImageFields(item.image_ru),
    image_en: mapImageFields(item.image_en),
  }
}

export function mapSocialFields(item?: Directus.Social | null, locale: string = defaultLocaleFull): ISocial | null {
  if (!item) return null

  const { url, url_en, name } = item

  if (!name || !(url || url_en)) return null

  return {
    ...item,
    url: locale === defaultLocaleFull ? item.url : item.url_en || item.url,
  }
}
